import spot01 from '../assets/images/walletAndSpot/1.png';
import spot02 from '../assets/images/walletAndSpot/2.png';
import spot03 from '../assets/images/walletAndSpot/3.png';
import spot04 from '../assets/images/walletAndSpot/4.png';
import spot05 from '../assets/images/walletAndSpot/5.png';
import spot06 from '../assets/images/walletAndSpot/6.png';
import spot07 from '../assets/images/walletAndSpot/7.png';
import spot08 from '../assets/images/walletAndSpot/8.png';
import spot09 from '../assets/images/walletAndSpot/9.png';

import postProfile01 from '../assets/images/walletAndSpot/postProfile01.png';
import postProfile02 from '../assets/images/walletAndSpot/postProfile02.png';
import postProfile03 from '../assets/images/walletAndSpot/postProfile03.png';






export interface uncSpotDataType {
    id: number,
    isLive: boolean,
    title: string,
    listeningProfiles: string[],
    peopleListening: number,
    postProfilePhoto: string,
    postProfileName: string,
    isHost: boolean,
    discription: string,
}



export const uncSpotData: uncSpotDataType[] = [
    {
        id: 1,
        isLive: true,
        title: 'WHy should #collectors buy your #NFTs. Tips for new artist 👀',
        listeningProfiles: [spot01, spot02, spot03],
        peopleListening: 85,
        postProfilePhoto: postProfile01,
        postProfileName: 'Shiesty Queen',
        isHost: true,
        discription: '💪Make Sure you are one of the owners in the first wave💪 🔥This is the first NFT🔥',
    },
    {
        id: 2,
        isLive: true,
        title: 'WHy should #collectors buy your #NFTs. Tips for new artist 👀',
        listeningProfiles: [spot04, spot05, spot06],
        peopleListening: 85,
        postProfilePhoto: postProfile02,
        postProfileName: 'Shiesty Queen',
        isHost: true,
        discription: '💪Make Sure you are one of the owners in the first wave💪 🔥This is the first NFT🔥',
    },
    {
        id: 3,
        isLive: true,
        title: 'WHy should #collectors buy your #NFTs. Tips for new artist 👀',
        listeningProfiles: [spot07, spot08, spot09],
        peopleListening: 85,
        postProfilePhoto: postProfile03,
        postProfileName: 'Shiesty Queen',
        isHost: true,
        discription: '💪Make Sure you are one of the owners in the first wave💪 🔥This is the first NFT🔥',
    },
    {
        id: 4,
        isLive: true,
        title: 'WHy should #collectors buy your #NFTs. Tips for new artist 👀',
        listeningProfiles: [spot01, spot02, spot03],
        peopleListening: 85,
        postProfilePhoto: postProfile01,
        postProfileName: 'Shiesty Queen',
        isHost: true,
        discription: '💪Make Sure you are one of the owners in the first wave💪 🔥This is the first NFT🔥',
    },
    {
        id: 5,
        isLive: true,
        title: 'WHy should #collectors buy your #NFTs. Tips for new artist 👀',
        listeningProfiles: [spot04, spot05, spot06],
        peopleListening: 85,
        postProfilePhoto: postProfile02,
        postProfileName: 'Shiesty Queen',
        isHost: true,
        discription: '💪Make Sure you are one of the owners in the first wave💪 🔥This is the first NFT🔥',
    },
    {
        id: 6,
        isLive: true,
        title: 'WHy should #collectors buy your #NFTs. Tips for new artist 👀',
        listeningProfiles: [spot07, spot08, spot09],
        peopleListening: 85,
        postProfilePhoto: postProfile03,
        postProfileName: 'Shiesty Queen',
        isHost: true,
        discription: '💪Make Sure you are one of the owners in the first wave💪 🔥This is the first NFT🔥',
    },
]



export interface uncSpot2BottomPeoplesDataType {
    id: number,
    photo: string,
    name: string,
    designation: string,
}


export const uncSpot2BottomPeoplesData: uncSpot2BottomPeoplesDataType[] = [
    {
        id: 1,
        photo: spot01,
        name: 'Shiesty Queen',
        designation: 'Host',
    },
    {
        id: 2,
        photo: spot02,
        name: 'Shiesty Queen',
        designation: 'Co Host',
    },
    {
        id: 3,
        photo: spot03,
        name: 'Shiesty Queen',
        designation: 'Speaker',
    },
    {
        id: 4,
        photo: spot04,
        name: 'Shiesty Queen',
        designation: 'Listener',
    },
    {
        id: 5,
        photo: spot05,
        name: 'Shiesty Queen',
        designation: 'Listener',
    },
    {
        id: 6,
        photo: spot06,
        name: 'Shiesty Queen',
        designation: 'Listener',
    },
    {
        id: 7,
        photo: spot07,
        name: 'Shiesty Queen',
        designation: 'Listener',
    },
    {
        id: 8,
        photo: spot08,
        name: 'Shiesty Queen',
        designation: 'Listener',
    },
    {
        id: 9,
        photo: spot09,
        name: 'Shiesty Queen',
        designation: 'Listener',
    },
]









